import React, { Component } from "react";
import "./Sidebar.css";

import Logo from "./Logo";
import Navigation from "./Navigation";

class Sidebar extends Component {
  render() {
    return (
      <nav className="sidebar-nav d-none d-md-block">
        <Logo />
        <Navigation data={this.props.data} {...this.props} />
      </nav>
    );
  }
}

export default Sidebar;
